import { requestJson } from './requestJson';

export async function postCreateTest(
  youtubeUrl: string,
  mode: 'blind' | 'live' = 'blind'
): Promise<{
  owned: boolean;
  test_id: string;
  dashboard_key: string;
  share_url: string;
  dashboard_url: string;
}> {
  return await requestJson('/api/tests', {
    method: 'POST',
    body: JSON.stringify({ youtube_url: youtubeUrl, mode })
  });
}
